module.exports = __webpack_public_path__ + "img/feature-item-insurance.4f138f79.svg";